exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-management[data-v-28dbbdfc]{margin-top:127px}.page-management .page-management-content[data-v-28dbbdfc]{margin-left:12px;margin-bottom:70px}.page-management .page-management-content .page-title[data-v-28dbbdfc]{font-weight:600;padding:30px 0 16px 0;font-size:32px}.page-management .page-management-content .page-content[data-v-28dbbdfc]{background-color:#fff;-webkit-box-shadow:0 3px 6px rgba(0,0,0,.050980392156862744);box-shadow:0 3px 6px rgba(0,0,0,.050980392156862744);border-radius:4px;min-height:374px;margin-bottom:130px}", ""]);

// exports
